// Expose global helper functions for optimistic cart updates
window.parseCartMoney = function(priceString) {
  if (!priceString) return 0;
  // Ignore any currency label and extract the numeric amount.
  const amount = String(priceString).match(/\d[\d,]*(?:\.\d{1,2})?/);
  if (!amount) return 0;
  const clean = amount[0].replace(/,/g, '');
  return Math.round(Number(clean) * 100) || 0;
};

window.getCartAmountCents = function(element) {
  if (!element) return 0;
  const stored = Number(element.dataset.cartAmount);
  return Number.isFinite(stored) && element.dataset.cartAmount !== undefined
    ? stored
    : window.parseCartMoney(element.textContent);
};

window.setCartAmountCents = function(element, cents) {
  if (!element) return;
  const amount = Math.max(0, Math.round(cents));
  element.dataset.cartAmount = amount;
  element.textContent = Shopify.formatMoney(amount, DT_THEME.moneyFormat);
};

window.expectedDeliveryFeeCents = function(merchandiseSubtotal) {
  if (merchandiseSubtotal <= 0 || merchandiseSubtotal >= 99900) return 0;
  try {
    if (localStorage.getItem('selected_mode') === 'pickup') return 0;
    const outlet = JSON.parse(localStorage.getItem('selected_outlet') || 'null');
    const distance = outlet && parseFloat(outlet.distance);
    if (!Number.isFinite(distance) || distance <= 4) return 7900;
    return distance <= 8 ? 14900 : 19900;
  } catch (_) {
    return 7900;
  }
};

window.updateDeliveryPreview = function(merchandiseDiff) {
  const cartPage = Boolean(document.querySelector('.cart-subtotal-value'));
  const progress = document.querySelector(cartPage ? '.delivery-progress-container' : '.cart-progress');
  if (!progress) return;

  const goal = Number(progress.dataset.goal) || 99900;
  const merchandiseSubtotal = Math.max(0, (Number(progress.dataset.subtotal) || 0) + merchandiseDiff);
  const previousFee = Number(progress.dataset.fee) || 0;
  const nextFee = window.expectedDeliveryFeeCents(merchandiseSubtotal);
  progress.dataset.subtotal = merchandiseSubtotal;
  progress.dataset.fee = nextFee;

  if (nextFee !== previousFee) {
    document.querySelectorAll('#CartDrawer-Checkout, #checkout-btn').forEach(button => {
      button.disabled = true;
      button.dataset.feePending = 'true';
    });
  }

  const total = document.querySelector(cartPage ? '.cart-grand-total-value' : '.totals__subtotal-value');
  if (total && nextFee !== previousFee) {
    window.setCartAmountCents(total, window.getCartAmountCents(total) + nextFee - previousFee);
  }

  const feeRow = document.querySelector(cartPage ? '.cart-item-card[data-delivery-charge="true"]' : '.cart-item[data-delivery-charge="true"]');
  if (feeRow) {
    feeRow.hidden = nextFee === 0;
    feeRow.style.display = nextFee === 0 ? 'none' : '';
    const feePrice = feeRow.querySelector('.cart-item-final-price');
    if (feePrice && nextFee > 0) feePrice.textContent = Shopify.formatMoney(nextFee, DT_THEME.moneyFormat);
  }

  if (cartPage) {
    progress.classList.toggle('success', merchandiseSubtotal >= goal);
    const under = progress.querySelector('.progress-text-under');
    const success = progress.querySelector('.progress-text-success');
    const bar = progress.querySelector('.delivery-progress-bar-bg');
    const fill = progress.querySelector('.delivery-progress-bar-fill');
    const remaining = progress.querySelector('.progress-remaining');
    if (under) under.style.display = merchandiseSubtotal >= goal ? 'none' : 'inline';
    if (success) success.style.display = merchandiseSubtotal >= goal ? 'inline' : 'none';
    if (bar) bar.style.display = merchandiseSubtotal >= goal ? 'none' : 'block';
    if (fill) fill.style.width = Math.min(100, merchandiseSubtotal * 100 / goal) + '%';
    if (remaining) remaining.textContent = Shopify.formatMoney(Math.max(0, goal - merchandiseSubtotal), DT_THEME.moneyFormat);
    const charge = document.querySelector('.delivery-charges-value');
    if (charge) charge.textContent = nextFee ? Shopify.formatMoney(nextFee, DT_THEME.moneyFormat) : 'Free';
  } else {
    const label = progress.querySelector('.free-shipping');
    if (label) label.classList.toggle('success', merchandiseSubtotal >= goal);
    const empty = progress.querySelector('[data-progress-empty]');
    const under = progress.querySelector('[data-progress-under]');
    const success = progress.querySelector('[data-progress-success]');
    const remaining = progress.querySelector('[data-progress-remaining]');
    const meter = progress.querySelector('progress');
    if (empty) empty.hidden = merchandiseSubtotal !== 0;
    if (under) under.hidden = merchandiseSubtotal === 0 || merchandiseSubtotal >= goal;
    if (success) success.hidden = merchandiseSubtotal < goal;
    if (remaining) remaining.textContent = Shopify.formatMoney(Math.max(0, goal - merchandiseSubtotal), DT_THEME.moneyFormat);
    if (meter) meter.value = Math.min(goal, merchandiseSubtotal);
  }
};

window.updateCartBubbleCount = function(newCount) {
  const bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count, #cart-icon-bubble span[aria-hidden="true"]');
  bubbles.forEach(bubble => {
    bubble.textContent = newCount;
  });
  if (newCount === 0) {
    document.querySelectorAll('.cart-count-bubble').forEach(el => el.style.display = 'none');
  } else {
    document.querySelectorAll('.cart-count-bubble').forEach(el => el.style.display = 'flex');
  }
};

window.updateCartTotalsOptimistically = function(centsDiff, itemQtyDiff) {
  const subtotalEl = document.querySelector('.cart-subtotal-value') || document.querySelector('.totals__subtotal-value');
  const grandTotalEl = document.querySelector('.cart-grand-total-value');
  
  if (subtotalEl) {
    let currentSubtotalCents = window.getCartAmountCents(subtotalEl);
    let newSubtotalCents = Math.max(0, currentSubtotalCents + centsDiff);
    
    window.setCartAmountCents(subtotalEl, newSubtotalCents);
    if (grandTotalEl) window.setCartAmountCents(grandTotalEl, window.getCartAmountCents(grandTotalEl) + centsDiff);
    
    window.updateDeliveryPreview(centsDiff);
  }
  
  // Update Bubble Count
  const bubbleSpan = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
  if (bubbleSpan) {
    let currentCount = parseInt(bubbleSpan.textContent) || 0;
    let newCount = Math.max(0, currentCount + itemQtyDiff);
    window.updateCartBubbleCount(newCount);
  }
};

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const card = this.closest('.cart-item-card') || this.closest('.cart-item');
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      
      if (card && cartItems) {
        // Parse quantity and unit price to deduct totals optimistically
        const qtyInput = card.querySelector('.quantity__input');
        const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
        const unitPriceCents = parseInt(card.dataset.unitPrice) || 0;
        
        // Animate and collapse card immediately
        card.style.transition = 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
        card.style.opacity = '0';
        card.style.transform = 'scale(0.9)';
        card.style.maxHeight = card.offsetHeight + 'px';
        // force reflow
        card.offsetHeight;
        card.style.maxHeight = '0px';
        card.style.paddingTop = '0px';
        card.style.paddingBottom = '0px';
        card.style.marginTop = '0px';
        card.style.marginBottom = '0px';
        card.style.border = 'none';
        card.style.overflow = 'hidden';
        
        // Deduct from subtotal and count bubble
        if (unitPriceCents > 0) {
          window.updateCartTotalsOptimistically(-unitPriceCents * qty, -qty);
        }
        
        // Wait for collapse transition before actual DOM removal, check if empty
        setTimeout(() => {
          card.remove();
          const remainingCards = cartItems.querySelectorAll('.cart-item-card:not([data-delivery-charge="true"]), .cart-item:not([data-delivery-charge="true"])');
          if (remainingCards.length === 0) {
            cartItems.classList.add('is-empty');
            
            // Toggle is-empty on parent cart-drawer
            const cartDrawer = cartItems.closest('cart-drawer') || document.querySelector('cart-drawer');
            if (cartDrawer) {
              cartDrawer.classList.add('is-empty');
              const drawerInner = cartDrawer.querySelector('.drawer__inner');
              if (drawerInner) drawerInner.classList.add('is-empty');
              const drawerDiv = cartDrawer.querySelector('.cart-drawer');
              if (drawerDiv) drawerDiv.classList.add('is-empty');
              const innerEmpty = cartDrawer.querySelector('.drawer__inner-empty');
              if (innerEmpty) innerEmpty.style.display = 'flex';
            }

            document.documentElement.classList.add('cart-empty-page');
            if (document.body) document.body.classList.add('cart-empty-page');
            const cartFooter = document.getElementById('main-cart-footer');
            if (cartFooter) cartFooter.classList.add('is-empty');
            const warnings = document.querySelectorAll('.cart__warnings, .cart-drawer__warnings');
            warnings.forEach(w => w.style.display = 'flex');
            const contents = document.querySelector('.cart__contents');
            if (contents) contents.style.display = 'none';
          }
        }, 300);
        
        // Sync with the server using item key
        cartItems.activeUpdates = (cartItems.activeUpdates || 0) + 1;
        const itemKey = this.dataset.key || this.getAttribute('data-key');
        cartItems.performServerUpdate(this.dataset.index, 0, null, itemKey);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.activeUpdates = 0;
    this.updateTimeouts = {};
    this.initOldValues();

    // Listen to change event directly without global debounce to allow instant updates
    this.addEventListener('change', this.onChange.bind(this));
  }

  initOldValues() {
    this.querySelectorAll('[name="updates[]"]').forEach((input) => {
      input.dataset.oldValue = input.value;
    });
  }

  onChange(event) {
    const input = event.target;
    if (input.name !== 'updates[]') return;
    
    const line = input.dataset.index;
    const key = input.dataset.key || input.getAttribute('data-key');
    const quantity = parseInt(input.value) || 0;
    
    // Update local UI (line prices, totals, bubble count) instantly
    this.updateTotalsAndLinePriceOptimistically(input);
    
    // Debounce the server request per line/key (450ms)
    const updateKey = key || line;
    if (this.updateTimeouts[updateKey]) {
      clearTimeout(this.updateTimeouts[updateKey]);
    } else {
      this.activeUpdates = (this.activeUpdates || 0) + 1;
    }
    
    this.updateTimeouts[updateKey] = setTimeout(() => {
      this.performServerUpdate(line, quantity, input.getAttribute('name'), key);
      delete this.updateTimeouts[updateKey];
    }, 450);
  }

  updateTotalsAndLinePriceOptimistically(input) {
    const newQty = parseInt(input.value) || 0;
    const oldQty = parseInt(input.dataset.oldValue) || 0;
    if (newQty === oldQty) return;
    input.dataset.oldValue = newQty;
    
    const card = input.closest('.cart-item-card') || input.closest('.cart-item');
    if (!card) return;
    const unitPrice = parseInt(card.dataset.unitPrice) || 0;
    
    const qtyDiff = newQty - oldQty;
    const centsDiff = unitPrice * qtyDiff;
    
    // Update card line price instantly
    const finalPriceEl = card.querySelector('.cart-item-final-price');
    if (finalPriceEl) {
      finalPriceEl.textContent = Shopify.formatMoney(unitPrice * newQty, DT_THEME.moneyFormat);
    }
    
    // Deduct/Add to totals
    window.updateCartTotalsOptimistically(centsDiff, qtyDiff);
    
    // If quantity is reduced to 0, collapse card and check if empty
    if (newQty === 0) {
      card.style.transition = 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
      card.style.opacity = '0';
      card.style.transform = 'scale(0.9)';
      card.style.maxHeight = card.offsetHeight + 'px';
      card.offsetHeight;
      card.style.maxHeight = '0px';
      card.style.paddingTop = '0px';
      card.style.paddingBottom = '0px';
      card.style.marginTop = '0px';
      card.style.marginBottom = '0px';
      card.style.border = 'none';
      card.style.overflow = 'hidden';
      
      setTimeout(() => {
        card.remove();
        const remainingCards = this.querySelectorAll('.cart-item-card:not([data-delivery-charge="true"]), .cart-item:not([data-delivery-charge="true"])');
        if (remainingCards.length === 0) {
          this.classList.add('is-empty');
          
          // Toggle is-empty on parent cart-drawer
          const cartDrawer = this.closest('cart-drawer') || document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.classList.add('is-empty');
            const drawerInner = cartDrawer.querySelector('.drawer__inner');
            if (drawerInner) drawerInner.classList.add('is-empty');
            const innerEmpty = cartDrawer.querySelector('.drawer__inner-empty');
            if (innerEmpty) innerEmpty.style.display = 'flex';
          }

          document.documentElement.classList.add('cart-empty-page');
          if (document.body) document.body.classList.add('cart-empty-page');
          const cartFooter = document.getElementById('main-cart-footer');
          if (cartFooter) cartFooter.classList.add('is-empty');
          const warnings = document.querySelector('.cart__warnings');
          if (warnings) warnings.style.display = 'block';
          const contents = document.querySelector('.cart__contents');
          if (contents) contents.style.display = 'none';
        }
      }, 300);
    }
  }

  performServerUpdate(line, quantity, name, key) {
    const payload = {
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    };

    if (key) {
      payload.id = key;
    } else if (typeof line === 'string' && (line.includes(':') || line.length > 10)) {
      payload.id = line;
    } else {
      payload.line = line;
    }

    const body = JSON.stringify(payload);

    // Shopify cart mutations must finish in click order; otherwise an older
    // response can replace the drawer after the latest optimistic update.
    this.serverUpdateQueue = (this.serverUpdateQueue || Promise.resolve())
      .catch(() => {})
      .then(() => fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } }))
      .then((response) => {
        if (!response.ok) throw new Error(`Cart update failed (${response.status})`);
        return response.json();
      })
      .then((parsedState) => {
        this.activeUpdates = Math.max(0, this.activeUpdates - 1);
        
        // Swap HTML only if no other updates are in progress
        if (this.activeUpdates === 0) {
          const isEmpty = !parsedState.items.some(item => item.product_handle !== 'delivery-charge' && item.handle !== 'delivery-charge');
          this.classList.toggle('is-empty', isEmpty);
          
          // Sync empty class on parent cart-drawer
          const cartDrawer = this.closest('cart-drawer') || document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.classList.toggle('is-empty', isEmpty);
            const drawerInner = cartDrawer.querySelector('.drawer__inner');
            if (drawerInner) drawerInner.classList.toggle('is-empty', isEmpty);
            const drawerDiv = cartDrawer.querySelector('.cart-drawer');
            if (drawerDiv) drawerDiv.classList.toggle('is-empty', isEmpty);
            const innerEmpty = cartDrawer.querySelector('.drawer__inner-empty');
            if (innerEmpty) innerEmpty.style.display = isEmpty ? 'flex' : 'none';
          }

          const cartItems = document.querySelector('cart-items');
          if (cartItems) {
            cartItems.classList.toggle('is-empty', isEmpty);
          }
          document.documentElement.classList.toggle('cart-empty-page', isEmpty);
          if (document.body) document.body.classList.toggle('cart-empty-page', isEmpty);
          const cartFooter = document.getElementById('main-cart-footer');
          if (cartFooter) cartFooter.classList.toggle('is-empty', isEmpty);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            if (elementToReplace) {
              elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          this.updateLiveRegions(line, parsedState.item_count);
          this.initOldValues();
          window.updateDeliveryPreview(0);
        }
      })
      .catch((error) => {
        this.activeUpdates = Math.max(0, this.activeUpdates - 1);
        console.error('Error syncing cart:', error);
        if (this.activeUpdates === 0) {
          const drawer = this.closest('cart-drawer');
          if (drawer && typeof drawer.syncCartDrawer === 'function') {
            drawer.syncCartDrawer(true);
          } else if (window.location.pathname.includes('/cart')) {
            window.location.reload();
          }
        }
      });

    return this.serverUpdateQueue;
  }

  updateQuantity(line, quantity, name) {
    this.performServerUpdate(line, quantity, name);
  }

  getSectionsToRender() {
    let sections = [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
    if (document.querySelector('#main-cart-footer .free-shipping')) {
      sections.push({
        id: 'main-cart-progress',
        section: document.getElementById('main-cart-progress').dataset.id,
        selector: '.js-contents',
      });
    }
    return sections;
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount && itemCount > 0) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      if (lineItemError && quantityElement) {
        const errorText = lineItemError.querySelector('.cart-item__error-text');
        if (errorText) {
          errorText.innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            quantityElement.value
          );
        }
      }
    } else {
      document.querySelectorAll('.cart-item__error-text').forEach(el => el.innerHTML = '');
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};

// Fetch all the details element.
document.addEventListener("DOMContentLoaded", () => {
  window.updateDeliveryPreview(0);
  const detailsElement = document.querySelector(".cart-group");
  const details = detailsElement.querySelectorAll("details");
  details.forEach((targetDetail) => {
    targetDetail.addEventListener("click", () => {
      details.forEach((detail) => {
        if (detail !== targetDetail) {
          detail.removeAttribute("open");
        }
      });
    });
  });
});


var details = [...document.querySelectorAll('details')];
document.addEventListener('click', function (e) {
  if (!details.some(f => f.contains(e.target))) {
    details.forEach(f => f.removeAttribute('open'));
  } else {
    details.forEach(f => !f.contains(e.target) ? f.removeAttribute('open') : '');
  }
});

//  var sBrowser, sUsrAg = navigator.userAgent;
//  if (sUsrAg.indexOf("Safari") > -1) {
//   sBrowser = "Safari";
// } else {
//   sBrowser = "unknown";
// }
// alert("You are using: " + sBrowser);

